



































































































import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

@Component({
    components: {

    }
}) export default class FeaturesContents extends Mixins(VueHoduCommon) {

    mounted() : void {
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            let scroll_offset = scroll ? scroll : 0;
            if (scroll_offset >= 50) {
                $(".ware_content").addClass("change");
            } else {
                $(".ware_content").removeClass("change");
            }
        });
    }

    /**
     * 주요기능 탭으로 이동
     */
    goFeatureTab(event : any, tab : string, target_id ?: string) : void {

        this.doSetFeaturesTab(tab);

        // 타겟이 지정되지 않은 경우 최상단으로 스크롤
        if( target_id == null ) {
            window.scrollTo(0, 0);
        } 
        
        // 타겟이 지정되어 있는 경우 타겟 위치로 이동
        else {
            setTimeout(() => {
                location.hash = `#${target_id}`;
                this.$router.push('/features').catch(e => {});
                
                // 스크롤이 맨 끝에 있는지 확인
                let bottomOfWindow : boolean = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight;
                
                // 스크롤이 끝나지 않았다면 헤더 높이인 70만큼 뺀다
                if( !bottomOfWindow ){
                    window.scrollTo(0, window.pageYOffset - 70);
                }

            }, 1);
        }
    }

}

